import React from 'react';
import CSVReader1 from "./CSVReader1";


const CSVImportRecordAtATimeWithProgress = ({importRecordPromise, onFinished, onError}) => {

    const [pcnt, setPcnt] = React.useState();
    const [metrics, setMetrics] = React.useState({});

    const processFiles = async (records) => {

        var count = 0;
        const total = records.length;
        const fail = [];
        const pass = [];
        var now = new Date().getTime();

        for (var i = 0; i < records.length; i++) {
            var record = records[i];
            ++count;
            setPcnt(count / total);
            try {
                await (importRecordPromise(record));
                pass.push({record: record});
            } catch (error) {
                fail.push({record: record, error: error});
            }
        }


        var end = new Date().getTime();
        const elapsed = end - now;

        const recordsPerSecond = records / elapsed * 1000;
        const totalRecords = records.length;
        const seconds = elapsed / 1000;

        const r = {
            perf: {recordsPerSecond: recordsPerSecond, totalRecords: totalRecords, seconds: seconds},
            passed: pass,
            fail: fail
        }


        onFinished(r);

    }

    return (
        <CSVReader1 onFileLoadFunc={processFiles} onFileLoadErrorFunc={onError}/>
    )

}

export default CSVImportRecordAtATimeWithProgress;